import {Component, Inject, Vue} from "vue-property-decorator";
import {AppSettings} from "~/lib/app-settings";
import {getHomePagesList, removeHomePage, publishHomePage, unPublishHomePage} from "~/modules/homepage/service";
import {MainContainer} from "~/components/main-container";
import {PageTitle} from "~/components/page-title";
import {icons} from "~/components/icon";
import {DataTable} from "~/components/data-table";
import {formatDate} from "~/lib/helpers/formatters";
import {ButtonMainCreate} from "~/components/buttons/button-main-create";
import {Getter} from "vuex-class";

export type HomePage = {
  uuid: string;
  label: string;
  createdAt: string;
  updatedAt: string;
  publicationStatus: number;
}

@Component
export class HomepagesList extends Vue {

  @Getter session;
  @Inject() appSettings: AppSettings;

  protected homepages: HomePage[] = [];
  protected loading: boolean = false;

  get headers() {
    return [
      {
        key: 'uuid',
        value: hp => hp.uuid,
        label: "UUID",
      },
      {
        key: 'label',
        value: hp => hp.label,
        label: "Libellé",
      },
      {
        key: 'createdAt',
        value: hp => formatDate(hp.createdAt),
        label: "Date de création"
      },
      {
        key: 'updatedAt',
        value: hp => formatDate(hp.updatedAt),
        label: "Date de modification"
      },
      {
        key: 'active',
        value: hp => hp.publicationStatus === 1 ?
          <span class="active">Actif</span> :
          <span class="inactive">Inactif</span>,
        label: "Statut",
        type: 'boolean'
      },
      {
        value: this.renderActions,
        label: "Actions"
      }
    ]
  }

  created(){
    if( ! this.session.functionalities?.allowHomepageEdition ){
      return this.$router.push({name: "home"});
    }
  }

  async mounted() {
    this.loading = true;
    this.homepages = await getHomePagesList(this.appSettings.clientUUID);
    this.loading = false;
  }

  renderActions(hp) {

    let actions = [];

    actions.push(
      <button
        class="button is-small"
        onClick={() => this.editHomePage(hp)}>Editer
      </button>
    );

    if (hp.publicationStatus !== 1) {
      actions.push(
        <button
          class="button is-small"
          onClick={() => this.publishHomePage(hp)}>Activer
        </button>
      );
      actions.push(
        <button
          class="button is-small is-danger"
          onClick={() => this.removeHomePage(hp)}>Supprimer
        </button>
      );
    } else {
      actions.push(
        <button
          class="button is-small"
          onClick={() => this.unPublishHomePage(hp)}>Desactiver
        </button>
      );
    }

    return <div class="actions">
      {actions}
    </div>
  }

  renderContent() {
    if (this.loading) return <p>Chargement</p>;
    return <DataTable headers={this.headers} tableData={this.homepages} />;
  }

  createHomePage() {
    this.$router.push({name: "homepages-edit", params: {uuid: "new"}});
  }

  editHomePage(hp){
    this.$router.push({name: "homepages-edit", params: {uuid: hp.uuid}});
  }

  async removeHomePage(hp) {
    try {
      await removeHomePage(hp.uuid);
      this.homepages = this.homepages.filter(item => item.uuid !== hp.uuid);
    } catch (err) {
      console.error(err);
    }
  }

  async publishHomePage(hp){
    try {
      await publishHomePage(hp.uuid);
      this.homepages = this.homepages.map( item => {
        item.publicationStatus = hp.uuid === item.uuid ? 1 : 0;
        return item;
      });
    } catch (err) {
      console.error(err);
    }
  }

  async unPublishHomePage(hp){
    try {
      await unPublishHomePage(hp.uuid);
      hp.publicationStatus = 0;
    } catch (err) {
      console.error(err);
    }
  }

  render() {
    return (
      <MainContainer>
        <PageTitle icon={icons.user} title="Pages d'accueil"/>
        <div class="page-content">
          {this.renderContent()}
          <ButtonMainCreate onClick={this.createHomePage} dataTooltip="Créer une page d'accueil"/>
        </div>
      </MainContainer>
    );
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-77f7041c/homepages-list.tsx" });